var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-f",attrs:{"id":"alipay"},domProps:{"innerHTML":_vm._s(_vm.alipay)}})
}
var staticRenderFns = []

export { render, staticRenderFns }